import React, { useEffect, useState } from 'react'
import SpinLoader from '../../../helpers/SpinLoader'
import { useAuthContext } from '../../../../context/auth'
import AccountForm from './AccountForm'
import FillDataAlert from '../FillDataAlert'
import { Typography } from 'antd'

import './index.less'
import { usePageLeaveContext } from '../../../../context/pageLeave'
import { useAccountContext } from '../../../../context/account'
import { IAccount } from '../../../../context/types'
import { useExpertProfilesContext } from '../../../../context/expertProfile'
import { useParams } from 'react-router-dom'

const { Title } = Typography

type UrlParam = {
	accountId: string
}

function Account() {
	const { auth } = useAuthContext()
	const { actions } = usePageLeaveContext()
	const { account } = useAccountContext()

	const { actions: expertProfilesActions } = useExpertProfilesContext()

	const [loading, setLoading] = useState<boolean>(true)
	const [userData, setUserData] = useState<IAccount>()
	const { accountId } = useParams() as UrlParam

	useEffect(() => {
		return () => {
			actions.setConditions({})
		}
	}, [])

	useEffect(() => {
		if (userData?.user?.isExpert) {
			const token = account?.token && !!accountId ? account.token : null
			expertProfilesActions.setError()
			if (accountId) {
				expertProfilesActions.getExpertProfiles(token)
			}
		}
	}, [userData?.user?.isExpert])

	useEffect(() => {
		if (account.token) {
			setUserData(account)
			if (!account.loading && !auth.loading) setLoading(false)
		} else if (!account.loading && !account.token) {
			setUserData(auth)
			if (!account.loading && !auth.loading) setLoading(false)
		}
	}, [account, auth])

	return (
		<div className="profile-form_wrapper">
			<Title level={3} style={{ marginBottom: 30 }}>
				Profile
			</Title>
			<FillDataAlert />
			<SpinLoader loading={!!loading || !!userData.loading}>
				<div>
					<AccountForm userData={userData} />
				</div>
			</SpinLoader>
		</div>
	)
}

export default Account
